<div class="flex flex-col">
  <div class="">{{vo.title}}</div>
  <div class="flex flex-row">
    <div [class]="getBarClass(vo)|async"
         class="bar rounded"
         [style.width]="getBarWidth(vo)"></div>
    <div class="pl-3" [class]="getTextClass(vo)|async">{{vo.valueLabel}}</div>
  </div>
</div>
